<template>
	<div class="p4">
		<p class="mb2">{{ $t("select_rejection_reasons") }}</p>
		<!-- Select box -->
		<core-form-input
			name="rejectedCodes"
			class="mb6"
			componentName="j-base-multi-select"
			:placeholder="$t('search_name_code')"
			v-model="rejectionCodes"
			:options="rejectionOptions"
			:allowLocalSearch="true"
		/>
		<p class="mb2">{{ $t("remarks") }}</p>
		<!-- Input -->
		<core-form-input
			name="rejectedRemarks"
			class="mb6"
			componentName="j-base-input-long-text"
			v-model="rejectionRemarks"
		/>
		<div class="fw7 fs3 c1 mb4">{{ `${$t("reasons")}:` }}</div>
		<ul class="pl6">
			<li class="mb1 fs3 lh125" v-for="(item, i) in rejectionCodes" :key="i">
				{{
					rejectionOptions
						.filter(option => option.value === item)
						.map(option => option.name)
						.toString()
				}}
			</li>
		</ul>
		<div class="flex xs-right">
			<j-button class="mt6" @click="onReject" type="error">{{
				$t("reject_claim")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api/"
import get from "lodash.get"

export default {
	props: {
		policyId: String,
		codes: {
			type: Array,
			default: []
		},
		remarks: String
	},

	components: {
		CoreFormInput,
		JButton
	},

	data() {
		return {
			rejectionCodes: [],
			rejectionOptions: [],
			rejectionRemarks: null
		}
	},

	methods: {
		async fetchRejectionOptions() {
			const res = await api.claimRejectionSettings({
				where: {
					id: this.policyId
				}
			})

			const options =
				res?.data?.policies?.list?.[0]?.acceptedOffer?.product?.claimSettings
					?.rejectionSettings?.codeNames || []

			this.rejectionOptions = options.map(item => {
				return {
					value: item.code,
					name: `${item.code} - ${item.name}`
				}
			})
		},

		async onReject() {
			const res = await api.rejectClaim({
				claimId: this.$route.params.id,
				codes: this.rejectionCodes,
				remarks: this.rejectionRemarks
			})
			this.$emit("rejected")
		}
	},

	created() {
		if (this.codes.length > 0)
			this.rejectionCodes = this.codes.map(item => item.code)
		if (this.remarks !== null) this.rejectionRemarks = this.remarks
		this.fetchRejectionOptions()
	}
}
</script>